/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsBlockCountRequest = {
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsBlockCountRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsBlockCountRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsBlockCountRequest$Outbound = {
  subnet: string | null;
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsBlockCountRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsBlockCountRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsBlockCountRequest
> = z.object({
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsBlockCountRequest$ {
  /** @deprecated use `GetApiV3MetricsBlockCountRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsBlockCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockCountRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsBlockCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockCountRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsBlockCountRequest$Outbound;
}

export function getApiV3MetricsBlockCountRequestToJSON(
  getApiV3MetricsBlockCountRequest: GetApiV3MetricsBlockCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsBlockCountRequest$outboundSchema.parse(
      getApiV3MetricsBlockCountRequest,
    ),
  );
}

export function getApiV3MetricsBlockCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsBlockCountRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3MetricsBlockCountRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsBlockCountRequest' from JSON`,
  );
}
